import { setTimeout } from "timers"

export const slideNext = (sliderWrapper: any) => {
    changeSlidePosition('', 'beforeEnd', sliderWrapper)
    const sliderItemWidth = `${sliderWrapper && sliderWrapper.children[0] && sliderWrapper.children[0].offsetWidth}`
    const item = sliderWrapper.children[0]
    if(item) {
        item.style.marginLeft = `-${sliderItemWidth}px`
    }
}

const changeSlidePosition = (marginLeft: string, position: string, sliderWrapper: any) => {
    const slideToChange = sliderWrapper.children && sliderWrapper.children[0]
    if(slideToChange) {
        slideToChange.style.marginLeft = marginLeft;
        sliderWrapper.removeChild(slideToChange);
        sliderWrapper.insertAdjacentHTML(position, slideToChange.outerHTML);
    }

}

export const clickNext = (sliderWrapper: any) => {
    let sliderItemWidth = `${sliderWrapper && sliderWrapper.children[0] && sliderWrapper.children[0].offsetWidth}`
    const sliderWidthInteger = parseInt(sliderItemWidth, 10);
    if(sliderWrapper) {
        sliderWrapper.scrollLeft += sliderWidthInteger;
    }
}

export const clickPrev = (sliderWrapper: any) => {
    let sliderItemWidth = `${sliderWrapper && sliderWrapper.children[0] && sliderWrapper.children[0].offsetWidth}`
    const sliderWidthInteger = parseInt(sliderItemWidth, 10);
    if(sliderWrapper) {
        sliderWrapper.scrollLeft -= sliderWidthInteger;
    }
}

export const cloneSlideStart = (wrapper: any) => {
        const childAmount = parseInt(wrapper.getAttribute("data-items-init"))
        const itemCloned = wrapper.children && wrapper.children[childAmount - 1] && wrapper.children[childAmount - 1].cloneNode(true)
        wrapper.prepend(itemCloned)
        const getItemClonedAppend = wrapper.children && wrapper.children.length && wrapper.children[wrapper.children.length - childAmount].cloneNode(true)
        wrapper.append(getItemClonedAppend)
}

export const slideTransform = (wrapper: any, amountSlide: number, wrapperId?: string, resizing?: boolean, prev?: boolean, next?: boolean, slideTransformInit?: number) => {
    if(wrapper && amountSlide) {
        for(let i = 0; i < wrapper.length; i++) {
            // Init Position
            if(wrapper[i] && wrapperId == undefined) {
                const slideWidth = getWidthSlide(wrapper, false, true)
                const totalTransform = slideWidth*amountSlide
                wrapper[i].style.transform = `translateX(${totalTransform}px)`
                wrapper[i] && wrapper[i].setAttribute('position', totalTransform)
            }

            // Click Navigator Position
            if(wrapper[i] && wrapperId && !resizing) {
                const slideWidth = getWidthSlide(wrapper, false, true)
                const totalTransform = slideWidth*amountSlide
                const getWrapperId = wrapper[i].getAttribute('id')
                const getSlideActiveIndex = parseInt(wrapper[i].getAttribute('slide-active'))
                const getCurrPosition = wrapper[i] && parseInt(wrapper[i].getAttribute('position'))
                if(getWrapperId === wrapperId) {
                    const getSliceItemInit = wrapper[i] && parseInt(wrapper[i].getAttribute('data-items-init'))
                    if(getSlideActiveIndex === 0 && prev && !next) {
                        if(wrapper[i]) {
                            setTimeout(() => {
                                wrapper[i].style.removeProperty('transition')
                                const getSlideActive = parseInt(wrapper[i].getAttribute('slide-active'))
                                if(slideTransformInit) {
                                    const total = (getSlideActive+slideTransformInit)*slideWidth
                                    wrapper[i].style.transform = `translateX(${-total}px)`
                                    wrapper[i] && wrapper[i].setAttribute('position', -total)
                                }
                            }, 400)
                            wrapper[i] && wrapper[i].setAttribute('slide-active', `${getSliceItemInit-1}`)
                            wrapper[i].style.transition = `transform 400ms cubic-bezier(0.25, 1, 0.5, 1)`
                            wrapper[i].style.transform = `translateX(${getCurrPosition-totalTransform}px)`
                        }

                    } else if (getSlideActiveIndex > 0 && prev && !next) {
                        if(wrapper[i]) {
                            const getSlideActive = parseInt(wrapper[i].getAttribute('slide-active'))
                            wrapper[i] && wrapper[i].setAttribute('slide-active', `${getSlideActive-1}`)
                            wrapper[i] && wrapper[i].setAttribute('position', getCurrPosition-totalTransform)
                            wrapper[i].style.transition = `transform 400ms cubic-bezier(0.25, 1, 0.5, 1)`
                            wrapper[i].style.transform = `translateX(${getCurrPosition-totalTransform}px)`
                        }
                    } else if ((getSlideActiveIndex < getSliceItemInit-1) && (getSlideActiveIndex >= 0) && next && !prev) {
                        if(wrapper[i]) {
                            wrapper[i] && wrapper[i].setAttribute('slide-active', `${getSlideActiveIndex+1}`)
                            wrapper[i] && wrapper[i].setAttribute('position', getCurrPosition-totalTransform)
                            wrapper[i].style.transition = `transform 400ms cubic-bezier(0.25, 1, 0.5, 1)`
                            wrapper[i].style.transform = `translateX(${getCurrPosition-totalTransform}px)`
                        }
                    } else if (getSlideActiveIndex === getSliceItemInit-1 && next && !prev) {
                        if(wrapper[i]) {
                            setTimeout(() => {
                                wrapper[i] && wrapper[i].style.removeProperty('transition')
                                wrapper[i].style.transform = `translateX(${getCurrPosition+((getSliceItemInit-1)*slideWidth)}px)`
                            }, 400)
                            wrapper[i].setAttribute('slide-active', `0`)
                            const total = (getSliceItemInit-1)*slideWidth
                            wrapper[i] && wrapper[i].setAttribute('position', `${getCurrPosition+total}`)
                            wrapper[i].style.transition = `transform 400ms cubic-bezier(0.25, 1, 0.5, 1)`
                            wrapper[i].style.transform = `translateX(${getCurrPosition-totalTransform}px)`
                        }
                    }


                    if(wrapper[0].parentNode.classList?.contains('container-full-width')) {
                        for(let a = 0; a < wrapper[i].childNodes.length; a++) {
                            const cNode = (wrapper[i].childNodes[a] as HTMLElement)?.getAttribute('data-index-number')
                            const getSlideActive = parseInt(wrapper[i].getAttribute('slide-active'))

                            if(cNode) {
                                if(parseInt(cNode) != getSlideActive) {
                                    (wrapper[i].childNodes[a] as HTMLElement)?.classList.add('not-active')
                                } else {
                                    (wrapper[i].childNodes[a] as HTMLElement)?.classList.remove('not-active')
                                }
                            }
                        }
                    }

                }
            }

            if(wrapper[i] && wrapperId && resizing) {
                const getWrapperId = wrapper[i].getAttribute('id')
                if(getWrapperId === wrapperId) {
                    const slideWidth = getWidthSlide(wrapper, false, true)
                    const totalTransform = slideWidth*amountSlide
                    wrapper[i].style.transform = `translateX(${totalTransform}px)`
                    wrapper[i] && wrapper[i].setAttribute('position', `${totalTransform}`)
                }
            }
        }
    }
}

export const navigatePagination = (wrapper: any) => {
    if(wrapper) {
        const slideActive = wrapper.getAttribute('slide-active')
        if(slideActive != null) {
            const parentNodeWrapper = wrapper.parentNode
            if(parentNodeWrapper?.nextSibling) {
                for(let a = 0; a < parentNodeWrapper?.nextSibling.childNodes.length; a++) {
                    let index = parseInt(slideActive);
                    let el = parentNodeWrapper?.nextSibling && parentNodeWrapper?.nextSibling.childNodes[index] && parentNodeWrapper?.nextSibling.childNodes[index].firstChild as HTMLElement
                    // for navigation that is bottom of the slider
                    if(parentNodeWrapper?.nextSibling?.querySelector(".splide-pagination")) {
                        const allChildren = parentNodeWrapper?.nextSibling?.querySelector(".splide-pagination")?.childNodes;
                        for(let i = 0; i < allChildren.length; i++) {
                            allChildren[i].firstChild.classList.remove('is-active')
                        }
                        el = parentNodeWrapper?.nextSibling?.querySelector(".splide-pagination")?.childNodes?.[index]?.firstChild;
                    } else {
                        const allChildren = parentNodeWrapper?.nextSibling.childNodes
                        for(let i = 0; i < allChildren.length; i++) {
                            allChildren[i].firstChild.classList.remove('is-active')
                        }
                    }
                    el && el.classList.add('is-active')
                }
            }
        }
    }
}

export const prevNextArrowPosition = (wrapper: any, marginLeft: boolean, marginRight: boolean) => {
    if(wrapper) {
        for(let i = 0; i < wrapper.length; i++) {
            const getWidth = getWidthSlide(wrapper, marginLeft, marginRight)
            const getSibling = wrapper[i].nextElementSibling
            if(getSibling) {
                const getNextButton = getSibling.childNodes[0].lastChild as HTMLElement
                if(getNextButton && getNextButton.classList.contains('navigate-next')) {
                    const getWidthButton = getNextButton.offsetWidth
                    getNextButton.style.left = `${getWidth-getWidthButton}px`
                }
            }
        }
    }
}

export const getWidthSlide = (wrapper: any, marginLeft: boolean, marginRight: boolean) => {
    let widthItem: any
    if(wrapper) {
        for(let i = 0; i < wrapper.length; i++) {
            const getWidth = wrapper[i].children[0] && wrapper[i].children[0].offsetWidth            
            const getStyleMarginLeft = wrapper[i].children[0] && getComputedStyle(wrapper[i].children[0]).getPropertyValue("margin-left");
            const getStyleMarginRight = wrapper[i].children[0] && getComputedStyle(wrapper[i].children[0]).getPropertyValue("margin-right");
            const leftmargin = marginLeft ? parseInt(getStyleMarginLeft) : 0
            const rightmargin = marginRight ? parseInt(getStyleMarginRight) : 0
            widthItem = parseInt(leftmargin+rightmargin+getWidth)
        }
    }
    return widthItem
}
